import type { SxProps, Theme } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import type { DesktopDatePickerProps } from '@mui/x-date-pickers/DesktopDatePicker';
import { DateTime } from 'luxon';
import type { FC, FocusEventHandler, ReactNode, Ref } from 'react';

type MUIDatePickerProps = DesktopDatePickerProps<DateTime>;

type DatePickerProps = Omit<
  MUIDatePickerProps,
  'value' | 'onChange' | 'onBlur' | 'minDate' | 'maxDate' | 'name'
> & {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  minDate?: string;
  maxDate?: string;
  error?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  placeholder?: string;
  name?: string;
  label?: ReactNode;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  inputRef?: Ref<HTMLInputElement>;
};

export const DatePicker: FC<DatePickerProps> = (props) => {
  const onChange = (value: DateTime | null): void => {
    if (!value) {
      props.onChange?.('');
    } else if (value.isValid) {
      props.onChange?.(value.toFormat('yyyy-MM-dd'));
    }
  };

  const { id, onBlur, error, fullWidth, helperText, placeholder } = props;

  return (
    <DesktopDatePicker<DateTime>
      {...props}
      value={props.value ? DateTime.fromISO(props.value) : null}
      onChange={onChange}
      minDate={props.minDate ? DateTime.fromISO(props.minDate) : undefined}
      maxDate={props.maxDate ? DateTime.fromISO(props.maxDate) : undefined}
      slotProps={{
        textField: {
          id,
          onBlur,
          fullWidth,
          error,
          helperText,
          placeholder,
        },
        actionBar: {
          actions: ['today', 'clear'],
        },
      }}
    />
  );
};
